// Display constants for the Team page; members come from GET /api/admin/team.
// Admin access maps to the API's superadmin role, Standard to admin.

export const TEAM_ACCESS = {
  admin: { label: "Admin", description: "Everything, including managing the team" },
  standard: { label: "Standard", description: "Reviews, support and account actions" },
};
